import MARKETING_TRIPBOARDS from './marketing-tripboards';

/** @todo deprecate once graphql returns marketing flag */
export function isMarketingBoard(boardId) {
    return MARKETING_TRIPBOARDS[boardId] === true;
}


// WEBPACK FOOTER //
// ./src/universal/tripboard/details/utils.js